import { IHistoricalOrder } from '@rbi-ctg/menu';
import { t } from 'state/intl/translations';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { getOrderNumber } from 'utils/order';

interface ICreateAriaLabel {
  buttonType?: 'add' | 'view' | 'reorder';
  name?: string;
  modifiers?: string[];
  order?: IHistoricalOrder;
}

export const useCreateOrderAriaLabel = () => {
  const enableOrderNumberGeneration = useFlag(LaunchDarklyFlag.ENABLE_ORDER_NUMBER_GENERATION);
  return ({ buttonType, name, modifiers, order }: ICreateAriaLabel) => {
    const isAddButtonType = buttonType === 'add';
    const isViewButtonType = buttonType === 'view';
    const isReorderButtonType = buttonType === 'reorder';

    if (isAddButtonType) {
      if (modifiers?.length) {
        const modString = modifiers.join(' ');
        return t('addItemToCartWithModifiers', { name, modifiers: modString });
      }
      return t('addItemToCart', { name });
    }

    if (!order) {
      return undefined;
    }
    if (order.cart.ticketNumber) {
      const ticketNumber = getOrderNumber(order, enableOrderNumberGeneration);

      if (isViewButtonType) {
        return t('viewDetailsWithOrderNumber', { ticketNumber });
      }

      if (isReorderButtonType) {
        return t('reorderWithOrderNumber', { ticketNumber });
      }
    } else {
      const orderDesc = order.cart.cartEntries.map(({ name: entryName }) => entryName).join(' ');
      if (isReorderButtonType) {
        return t('reorderWithOrderDescription', { orderDesc });
      }
      if (isViewButtonType) {
        return t('viewOrderWithDescription', { orderDesc });
      }
    }
    return undefined;
  };
};
